import Cookies from 'universal-cookie';
const cookies = new Cookies();

const getBaseURL = (useWindowLocation = false) => {
  if (useWindowLocation) {
    const portRegex = /:([0-9]+)/gm;
    return window.location.href.replace(portRegex, ':1337');
  }
  //return "http://localhost:8000/"
  // return "http://backend:8000/"
  // return "http://10.0.0.25:8000/"
  return process.env.REACT_APP_API_HOST || 'http://localhost:8000/';
};

const BASE_URL = getBaseURL(process.env.REACT_APP_USE_WINDOW_LOCATION);

const defaultHeaders = () => {
  var headers = new Headers();
  const userToken = cookies.get('userToken');
  headers.append('Content-Type', 'application/json');
  headers.append('Authorization', `Bearer ${userToken}`);

  return headers;
};

const get = async (endpoint, options) => {
  const requestOptions = {
    method: 'GET',
    headers: defaultHeaders(),
  };

  const response = await fetch(`${BASE_URL}${endpoint}`, requestOptions);
  const json = await response.json();
  if (json.code === 'user_not_found' || json.code === 'token_not_valid') {
    cookies.remove('userToken');
  }
  return { response, json };
};

const post = async (endpoint, body) => {
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(body),
    headers: defaultHeaders(),
  };

  return fetch(`${BASE_URL}${endpoint}`, requestOptions);
};

const put = async (endpoint, body) => {
  const requestOptions = {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: defaultHeaders(),
  };

  return fetch(`${BASE_URL}${endpoint}`, requestOptions);
};

const patch = async (endpoint, body) => {
  const requestOptions = {
    method: 'PATCH',
    body: JSON.stringify(body),
    headers: defaultHeaders(),
  };

  return fetch(`${BASE_URL}${endpoint}`, requestOptions);
};

export const uploadFileToOrder = async (order_number, file, description, fileType, isFtp) => {
  let formdata = new FormData();
  
  if (isFtp) {
    // Caso normal: enviar el archivo completo
    formdata.append('file_uploaded', file, file.name);
  } else {
    // Caso donde isFtp es false: enviar solo metadata del archivo como campos separados
    formdata.append('file_name', file.name);
    // No enviamos file_uploaded cuando isFtp es false
  }
  
  formdata.append('order', order_number);
  formdata.append('description', description);
  formdata.append('file_type', fileType);
  formdata.append('is_ftp', isFtp);

  const headers = defaultHeaders();
  headers.delete('Content-Type');

  var requestOptions = {
    method: 'POST',
    body: formdata,
    headers,
    redirect: 'follow',
  };

  return await fetch(`${BASE_URL}api/upload/`, requestOptions);
};

export const updateFileToOrder = async (file) => {
  let formdata = new FormData();
  formdata.append('file', file);

  const headers = defaultHeaders();
  headers.delete('Content-Type');

  var requestOptions = {
    method: 'PUT',
    body: formdata,
    headers,
    redirect: 'follow',
  };

  return fetch(`${BASE_URL}api/upload/`, requestOptions);
};

export const deleteFileToOrder = async (file, observations) => {
  let formdata = new FormData();
  formdata.append('file', file);
  formdata.append('observations', observations);

  const headers = defaultHeaders();
  headers.delete('Content-Type');

  var requestOptions = {
    method: 'DELETE',
    body: formdata,
    headers,
    redirect: 'follow',
  };

  return fetch(`${BASE_URL}api/upload/`, requestOptions);
};

export const uploadBill = async (file, description, period) => {
  let formdata = new FormData();
  formdata.append('file_uploaded', file, file.name);
  formdata.append('description', description);
  formdata.append('period', period);

  const headers = defaultHeaders();
  headers.delete('Content-Type');

  var requestOptions = {
    method: 'POST',
    body: formdata,
    headers,
    redirect: 'follow',
  };

  return fetch(`${BASE_URL}api/facturas/`, requestOptions);
};

export const adminUpdateBill = async (id, body) => {
  return put(`api/facturas/${id}/`, body);
};

export const login = async (username, password) => {
  let formdata = new FormData();
  formdata.append('username', username);
  formdata.append('password', password);

  let requestOptions = {
    method: 'POST',
    body: formdata,
  };

  try {
    const response = await fetch(`${BASE_URL}token/`, requestOptions);
    return response;
  } catch (error) {
    console.log('Error trying to login', error);
  }
};

export const register = async (user) => {
  return post('register/', user);
};

export const getProfileData = async () => {
  return get('api/profile');
};

export const getProfilesData = async () => {
  const { json } = await get('api/profiles');
  return json;
};

export const getordersRequest = async (limit = 10, offset = 0) => {
  return get(`api/ordenes/?limit=${limit}&offset=${offset}`);
};

export const getBills = async (limit = 10, offset = 0, filters) => {
  let queryString = Object.keys(filters)
    .map((key) => key + '=' + filters[key])
    .join('&');

  return get(`api/facturas/?limit=${limit}&offset=${offset}&${queryString}`);
};

export const getAudity = async (limit = 10, offset = 0, filters) => {
  let queryString = Object.keys(filters)
    .map((key) => `${key}=${filters[key]}`)
    .join('&');

  return get(`api/auditoria/?limit=${limit}&offset=${offset}&${queryString}`);
};

export const getAudityProcess = async () => {
  const { json } = await get('api/procesos_auditoria');
  return json;
};

export const getAudityAction = async (process) => {
  const { json } = await get(`api/acciones_auditoria/?process=${process}`);
  return json;
};

export const searchOrderRequest = async (filters) => {
  var requestOptions = {
    method: 'GET',
    headers: defaultHeaders(),
  };

  let queryString = Object.keys(filters)
    .map((key) => key + '=' + filters[key])
    .join('&');

  const response = await fetch(`${BASE_URL}api/ordenes/?${queryString}`, requestOptions);
  return response.json();
};

export const getOrderRequest = async (orderNumber) => {
  const { json } = await get(`orden/${orderNumber}`);
  return json;
};

export const getOrderMaterialStatusRequest = async (orderNumber) => {
  const { json } = await get(`orden/${orderNumber}/materials_status`);
  return json;
};

export const getMedias = async (filter) => {
  if (filter) {
    return get(`api/medios/?${filter}`);
  }
  return get(`api/medios/`);
};

export const getAdvertisers = async () => {
  return get('api/anun/');
};

export const getAgencies = async () => {
  return get('api/agencias/');
};

export const updateOrder = async (orderNumber, body) => {
  return post(`orden/${orderNumber}/`, body);
};

export const getOrdersStatusAdmin = async (filters) => {
  var requestOptions = {
    method: 'GET',
    headers: defaultHeaders(),
  };

  let queryString = Object.keys(filters)
    .map((key) => key + '=' + filters[key])
    .join('&');

  const response = await fetch(`${BASE_URL}api/notificar/?${queryString}`, requestOptions);
  return response.json();
};

export const downloadMaterial = async (orderNumber, body) => {
  return post(`orden/${orderNumber}/materiales/`, body);
};

export const downloadUserAttachment = async (orderNumber, body) => {
  return post(`orden/${orderNumber}/adjuntos/`, body);
};

export const containerStatus = async () => {
  return post('container_status/');
};

export const getConfigData = async () => {
  const { json } = await get('api/conf/');
  return json;
};

export const postConfigData = async (body) => {
  const response = await post('api/conf/', body);
  return response.json();
};

export const postForgetPassword = async (body) => {
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  var requestOptions = {
    method: 'POST',
    body: JSON.stringify(body),
    headers: myHeaders,
  };

  return fetch(`${BASE_URL}request_reset_password/`, requestOptions);
};

export const postResetPassword = async (body) => {
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  var requestOptions = {
    method: 'POST',
    body: JSON.stringify(body),
    headers: myHeaders,
  };

  return fetch(`${BASE_URL}reset_password/`, requestOptions);
};

export const getMyNotifications = async () => {
  const { json } = await get('api/mis_notificaciones/');
  return json;
};

export const updateUser = async (id, body) => {
  return patch(`api/user_admin/${id}/`, body);
};

export const deleteUser = async (userId) => {
  var requestOptions = {
    method: 'DELETE',
    body: { user: userId },
    headers: defaultHeaders(),
  };

  return fetch(`${BASE_URL}api/user_admin/${userId}`, requestOptions);
};

export const getBillFile = async (body) => {
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  var requestOptions = {
    method: 'POST',
    body,
    headers: myHeaders,
  };

  return post(`get_bill_file/`, requestOptions);
};

export const updateUserProfile = async (profileID, body) => {
  return patch(`api/profiles/${profileID}/`, body);
};

export const GetOrderMediaReport = async (orderNumber) => {
  return post(`reports/order_media_report/${orderNumber}/`);
};

export const getOrderDataReport = async (body) => {
  return post(`order_report/`, body);
};
